<div class="cas-registry-container">
    <div class="cas-registry-item-container">
        <div class="cas-registry-item-input-container">
            <mat-form-field appearance="outline" class="cas-registry-form-field">
                <mat-label>{{ formFieldTitle }}</mat-label>
                <input matInput #casRegistryNumberInput [(ngModel)]="casRegistryNumber"
                    class="cas-registry cas-registry-item-input"
                    (keyup.enter)="updateCasRegistryNumber($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updateCasRegistryNumber($event)" />
                <mat-icon matSuffix (mousedown)="clearCasRegistryNumberInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError(formFieldName, 'required')">
            This is a required field.
        </div>
        <div class="input-error" *ngIf="!hasFieldValidationError(formFieldName, 'required') && hasFieldValidationError(formFieldName, 'pattern')">
            Invalid number entered.
        </div>
    </div>
    <div class="cas-registry-info cas-registry-info-text" *ngIf="displayInfoText">
        {{ infoText }}
    </div>
</div>